import isChromatic from 'chromatic/isChromatic';
import { useState } from 'react';
import styles from './GlowOrbIcon.module.css';

export function GlowOrbIcon(props: React.SVGProps<SVGSVGElement>) {
  const [startDelay] = useState(() => (isChromatic() ? 0 : Math.random() * -6));

  return (
    <svg
      viewBox="0 0 16 16"
      height="16"
      width="16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden={true}
      {...props}
    >
      <circle
        className={styles.GlowOrbIcon_outerRing}
        style={{ '--start-delay': `${startDelay}s` } as React.SVGProps<SVGCircleElement>['style']}
        cx="8"
        cy="8"
        r="8"
        fill="url(#gradient-light)"
      />
      <circle cx="8" cy="8" r="3" fill="#30D158" />
      <defs>
        <radialGradient id="gradient-light" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
          <stop offset="0%" style={{ stopColor: 'hsl(135, 61.5%, 75%)', stopOpacity: 0 }} />
          <stop offset="100%" style={{ stopColor: 'hsl(135, 61.5%, 75%)', stopOpacity: 1 }} />
        </radialGradient>
        <radialGradient id="gradient-dark" cx="50%" cy="50%" r="50%" fx="50%" fy="50%">
          <stop offset="0%" style={{ stopColor: 'hsla(135, 61.5%, 94.9%, 35%)', stopOpacity: 0 }} />
          <stop offset="100%" style={{ stopColor: 'hsla(135, 61.5%, 94.9%, 35%)', stopOpacity: 1 }} />
        </radialGradient>
      </defs>
    </svg>
  );
}
